/* ============================================================
   RUN 42 — fix synchro variante → formulaire d'ajout au panier
   Le thème met à jour l'URL (?variant=) et le radio quand on change
   de taille, mais pas toujours le <input name="id"> du formulaire
   (le bloc offre inséré entre le picker et le form casse le câblage).
   Résultat : l'ATC ajoutait toujours la taille par défaut (S).
   Ce script force input[name="id"] = variante de l'URL.
   ============================================================ */
(function () {
  function syncCartFormIds() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (!m) return;
    var id = m[1];
    var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== id) inputs[i].value = id;
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest &&
        e.target.closest('variant-selects, .acjjdo-product-variant-picker, fieldset')) {
      setTimeout(syncCartFormIds, 60);
      setTimeout(applyGalleryColorFilter, 80);
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest &&
        e.target.closest('.acjjdo-product-variant-picker, variant-selects, label.acjjdo-swatch')) {
      setTimeout(syncCartFormIds, 120);
      setTimeout(applyGalleryColorFilter, 140);
    }
  }, true);

  window.addEventListener('popstate', syncCartFormIds);
  // filet de sécurité : rattrape tout changement de variante
  setInterval(syncCartFormIds, 500);
  if (document.readyState !== 'loading') syncCartFormIds();
  else document.addEventListener('DOMContentLoaded', syncCartFormIds);

  /* ----------------------------------------------------------------
     Un seul compte à rebours visible = la barre sticky du bas.
     Le bloc inline <acjjdo-countdown> reste dans le DOM (il crée la
     session localStorage que le sticky lit), mais on le rend invisible.
     On injecte le CSS ici car le <style> brut d'une section imbriquée
     comme bloc n'est pas appliqué par ce thème → l'injection JS, si.
     On ne touche PAS .acjjdo-sticky-atc__countdown (le timer du bas).
     ---------------------------------------------------------------- */
  function hideInlineCountdown() {
    if (document.getElementById('r42-hide-inline-cd')) return;
    if (!document.querySelector('acjjdo-countdown')) return;
    var st = document.createElement('style');
    st.id = 'r42-hide-inline-cd';
    st.textContent = 'acjjdo-countdown.acjjdo-countdown{position:absolute!important;width:1px!important;' +
      'height:1px!important;margin:-1px!important;padding:0!important;border:0!important;overflow:hidden!important;' +
      'clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;opacity:0!important;pointer-events:none!important;}';
    document.head.appendChild(st);
  }
  hideInlineCountdown();
  document.addEventListener('DOMContentLoaded', hideInlineCountdown);
  // le custom element peut s'upgrader tard : on retente brièvement
  var cdTries = 0;
  var cdTimer = setInterval(function () {
    hideInlineCountdown();
    if (document.getElementById('r42-hide-inline-cd') || ++cdTries > 20) clearInterval(cdTimer);
  }, 200);

  /* ----------------------------------------------------------------
     Anti « écran qui remonte » au choix d'une taille.
     Le JS du thème (econamy) re-render la section produit quand on
     change de variante → le navigateur perd l'ancrage de scroll et
     saute vers le haut. On mémorise la position au clic sur une
     taille, puis on la restaure sur ~600ms UNIQUEMENT si ça a sauté
     vers le HAUT (on ne combat jamais un scroll vers le bas voulu).
     ---------------------------------------------------------------- */
  var lockActive = false;
  var lockY = 0;
  // Corrige AVANT le paint : l'événement scroll se déclenche de façon synchrone
  // quand le thème saute vers le haut → on remet la position tout de suite,
  // donc aucun mouvement visible (au lieu de corriger une frame trop tard).
  function clampScroll() {
    if (lockActive && window.pageYOffset < lockY - 2) window.scrollTo(0, lockY);
  }
  window.addEventListener('scroll', clampScroll, true);

  /* Le header « hide-on-scroll » du thème se replie avec une marge négative
     (= sa hauteur, 81 px) quand il est caché, et le scroll-anchoring est coupé
     (overflow-anchor:none dans acjjdo-header.liquid). Au choix d'une taille, le
     re-render fait ressortir le header → +81 px dans le flux → la page saute
     (mesuré 28/08 : gallery 87→168, scrollY 700→677). Tant que le verrou est
     actif, si le thème retire `is-hidden`, on le remet dans la même frame :
     rien ne bouge, pas de flicker. Hors verrou le comportement normal reprend. */
  var headerObs = null;
  function keepHeaderHidden() {
    var h = document.querySelector('.acjjdo-header[data-hide-on-scroll="true"]');
    if (!h || !h.classList.contains('is-hidden') || !window.MutationObserver) return;
    if (headerObs) headerObs.disconnect();
    headerObs = new MutationObserver(function () {
      if (lockActive && !h.classList.contains('is-hidden')) h.classList.add('is-hidden');
    });
    headerObs.observe(h, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { if (headerObs) { headerObs.disconnect(); headerObs = null; } }, 900);
  }

  function lockScroll() {
    lockY = window.pageYOffset;
    lockActive = true;
    keepHeaderHidden();
    var frames = 0;
    (function raf() {
      clampScroll();
      if (++frames < 48) requestAnimationFrame(raf); // ~800ms de garde (re-render + header)
      else lockActive = false;
    })();
  }
  // Relâche IMMÉDIATEMENT si l'utilisateur scrolle de lui-même (molette, swipe,
  // clavier) : on ne combat que le saut involontaire du thème, jamais un scroll
  // voulu. Sans ça, la page paraissait « bloquée » ~0,7 s après le choix couleur.
  function releaseLock() { lockActive = false; }
  window.addEventListener('wheel', releaseLock, { passive: true });
  window.addEventListener('touchmove', releaseLock, { passive: true });
  window.addEventListener('keydown', function (e) {
    if (/^(Arrow|Page|Home|End| |Spacebar)/.test(e.key || '')) releaseLock();
  }, true);
  function isVariantTarget(e) {
    return e.target && e.target.closest &&
      e.target.closest('.acjjdo-swatch, .acjjdo-product-variant-picker, variant-selects, .acjjdo-product-form__option');
  }
  /* Le vrai saut (mesuré 28/08) : l'<input type=radio> du swatch est masqué en
     0×0 HORS du carré (plus haut dans la page). Le clic sur le label le
     focalise → le navigateur scrolle pour l'amener sous `scroll-padding-top`
     (168 px) → scrollY 700→677, en smooth. On focalise l'input NOUS-MÊMES au
     pointerdown avec preventScroll : le focus natif qui suit ne bouge plus. */
  /* …et ce qui déclenche VRAIMENT le défilement : `html { scroll-padding-top:
     calc(header + annonce) }` (critical.css, ~168 px). Tout élément focalisé par
     un tap dans les 168 px du haut de l'écran est « remonté » sous cette marge —
     même quand le header est caché. Le pré-focus ne suffit pas (le tap refocalise).
     On annule la marge le temps du tap (900 ms), puis on la rend au thème :
     ses ancres (#faq, etc.) continuent de s'aligner sous le header. Mesuré :
     700→700 et 400→400 au lieu de 700→677. */
  var spTimer = null;
  function suspendScrollPadding() {
    var root = document.documentElement;
    root.style.setProperty('scroll-padding-top', '0px', 'important');
    clearTimeout(spTimer);
    spTimer = setTimeout(function () { root.style.removeProperty('scroll-padding-top'); }, 900);
  }
  function prefocusSwatch(e) {
    var label = e.target && e.target.closest && e.target.closest('label.acjjdo-swatch');
    if (!label) return;
    suspendScrollPadding();
    var inp = label.control || label.querySelector('input') ||
      (label.htmlFor ? document.getElementById(label.htmlFor) : null);
    if (inp && inp.focus && document.activeElement !== inp) {
      try { inp.focus({ preventScroll: true }); } catch (err) { /* vieux navigateur */ }
    }
  }
  // pointerdown : capture la position AVANT que le clic/re-render ne démarre
  document.addEventListener('pointerdown', function (e) { if (isVariantTarget(e)) { lockScroll(); prefocusSwatch(e); } }, true);
  document.addEventListener('click', function (e) { if (isVariantTarget(e)) lockScroll(); }, true);

  /* ----------------------------------------------------------------
     Filtre galerie par COULEUR (photos du HAUT de la page produit).
     Les photos couleur portent un texte alternatif = "vert"/"orange"/
     "noir" ; les infographies ont un alt neutre (titre produit) → elles
     restent visibles pour toutes les couleurs. Quand la couleur choisie
     change, on masque les slides + vignettes des autres couleurs et on
     recale la galerie sur la 1re photo de la couleur. Le RESTE de la page
     ne bouge pas. On ne remplace pas le contrôleur econamy : simple toggle
     de classe + reset scroll, idempotent (réappliqué après un re-render de
     variante) et sans effet si le produit n'a pas d'option couleur.
     ---------------------------------------------------------------- */
  var R42_GAL_HIDE = 'r42-media-hidden';
  var r42LastColor = null;

  function ensureGalleryHideStyle() {
    if (document.getElementById('r42-gal-filter-style')) return;
    var st = document.createElement('style');
    st.id = 'r42-gal-filter-style';
    st.textContent = '.' + R42_GAL_HIDE + '{display:none!important;}';
    document.head.appendChild(st);
  }

  // Fieldset de l'option Couleur (même détection de nom que le thème).
  function r42ColorFieldset() {
    var opts = document.querySelectorAll('.acjjdo-product-form__option');
    for (var i = 0; i < opts.length; i++) {
      var lg = opts[i].querySelector('legend, .acjjdo-product-form__option-label');
      var t = (lg ? lg.textContent : '').toLowerCase();
      if (/couleur|colou?r|farbe|colore/.test(t)) return opts[i];
    }
    return null;
  }

  // Vocabulaire couleur = valeurs des swatches de l'option Couleur.
  function r42ColorVocab(fs) {
    var out = [];
    var ins = fs.querySelectorAll('input.acjjdo-swatch__input, input[type="radio"], option');
    for (var i = 0; i < ins.length; i++) {
      var v = (ins[i].value || '').toLowerCase().trim();
      if (v && out.indexOf(v) === -1) out.push(v);
    }
    return out;
  }

  // Couleur sélectionnée (swatch coché, sinon libellé affiché).
  function r42SelectedColor(fs) {
    var checked = fs.querySelector('input.acjjdo-swatch__input:checked, input[type="radio"]:checked');
    if (checked && checked.value) return checked.value.toLowerCase().trim();
    var span = fs.querySelector('[data-option-value]');
    if (span && span.textContent) return span.textContent.toLowerCase().trim();
    return null;
  }

  // Quelle couleur du vocab décrit cet alt ? null = neutre (infographie).
  function r42AltColor(alt, vocab) {
    alt = (alt || '').toLowerCase();
    for (var i = 0; i < vocab.length; i++) {
      if (alt.indexOf(vocab[i]) !== -1) return vocab[i];
    }
    return null;
  }

  function r42EscapeId(id) {
    return (window.CSS && CSS.escape) ? CSS.escape(id) : id;
  }

  function applyGalleryColorFilter() {
    var gallery = document.querySelector('acjjdo-product-gallery, .acjjdo-gallery');
    if (!gallery) return;
    var fs = r42ColorFieldset();
    if (!fs) return;                       // pas d'option couleur → galerie inchangée
    var sel = r42SelectedColor(fs);
    if (!sel) return;
    var vocab = r42ColorVocab(fs);
    if (vocab.indexOf(sel) === -1) return; // sélection hors vocab → on ne touche à rien

    ensureGalleryHideStyle();
    var slides = gallery.querySelectorAll('.acjjdo-gallery__slide');
    if (!slides.length) return;

    // Garde-fou : si aucune photo pour la couleur choisie, tout montrer.
    var matchCount = 0, i, img, c;
    for (i = 0; i < slides.length; i++) {
      img = slides[i].querySelector('img');
      if (r42AltColor(img && img.getAttribute('alt'), vocab) === sel) matchCount++;
    }
    var enable = matchCount > 0;

    var firstVisible = null;
    for (i = 0; i < slides.length; i++) {
      var s = slides[i];
      img = s.querySelector('img');
      c = r42AltColor(img && img.getAttribute('alt'), vocab);
      var hide = enable && !!c && c !== sel;   // slide d'une AUTRE couleur
      s.classList.toggle(R42_GAL_HIDE, hide);
      var id = s.getAttribute('data-media-id');
      if (id) {
        var thumbs = gallery.querySelectorAll('.acjjdo-gallery__thumb[data-thumb-target="' + r42EscapeId(id) + '"]');
        for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle(R42_GAL_HIDE, hide);
      }
      if (!hide && !firstVisible) firstVisible = s;
    }

    // Recale la galerie sur la 1re photo visible UNIQUEMENT si la couleur a changé
    // (pas à chaque re-render : on ne yank pas le scroll de l'utilisateur).
    if (sel !== r42LastColor) {
      r42LastColor = sel;
      if (firstVisible) {
        var main = gallery.querySelector('.acjjdo-gallery__main, [data-gallery-main]');
        if (main) {
          try {
            main.scrollLeft += firstVisible.getBoundingClientRect().left - main.getBoundingClientRect().left;
          } catch (e) { main.scrollLeft = 0; }
        }
        var actS = gallery.querySelectorAll('.acjjdo-gallery__slide--active');
        for (var a = 0; a < actS.length; a++) actS[a].classList.remove('acjjdo-gallery__slide--active');
        firstVisible.classList.add('acjjdo-gallery__slide--active');
        var fid = firstVisible.getAttribute('data-media-id');
        var actT = gallery.querySelectorAll('.acjjdo-gallery__thumb--active');
        for (var b = 0; b < actT.length; b++) {
          actT[b].classList.remove('acjjdo-gallery__thumb--active');
          actT[b].removeAttribute('aria-current');
        }
        if (fid) {
          var ft = gallery.querySelector('.acjjdo-gallery__thumb[data-thumb-target="' + r42EscapeId(fid) + '"]');
          if (ft) { ft.classList.add('acjjdo-gallery__thumb--active'); ft.setAttribute('aria-current', 'true'); }
        }
      }
    }
  }

  // Réapplique le filtre après un re-render de la galerie par le thème.
  function observeGallery() {
    var gallery = document.querySelector('acjjdo-product-gallery, .acjjdo-gallery');
    if (!gallery || gallery.__r42galObs) return;
    var main = gallery.querySelector('.acjjdo-gallery__main, [data-gallery-main]');
    if (!main || !window.MutationObserver) return;
    gallery.__r42galObs = true;
    var mo = new MutationObserver(function () { applyGalleryColorFilter(); });
    mo.observe(main, { childList: true });
  }

  function initGalleryFilter() {
    ensureGalleryHideStyle();
    applyGalleryColorFilter();
    observeGallery();
  }
  if (document.readyState !== 'loading') initGalleryFilter();
  else document.addEventListener('DOMContentLoaded', initGalleryFilter);
  // le contrôleur galerie peut s'upgrader tard : on retente brièvement
  var galTries = 0;
  var galTimer = setInterval(function () {
    observeGallery();
    applyGalleryColorFilter();
    if (++galTries > 15) clearInterval(galTimer);
  }, 300);
})();

/* ============================================================
   RUN 42 — estimation livraison : le samedi compte, seul le
   dimanche est sauté. Le widget du thème (mode "calculated")
   saute sam+dim, ce qui gonfle l'affichage (~4 jours de plus).
   Le JS du thème est obfusqué → on recalcule ici et on écrase
   le texte rendu, mêmes réglages (min/max/cutoff du bloc).
   ============================================================ */
(function () {
  function addDaysSkipSunday(base, n) {
    var d = new Date(base), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // 0 = dimanche, seul jour sauté
    }
    return d;
  }
  function fmt(d, withMonth) {
    return d.toLocaleDateString('fr-FR', withMonth ? { day: 'numeric', month: 'long' } : { day: 'numeric' });
  }
  function applyDeliverySundayOnly() {
    var els = document.querySelectorAll('acjjdo-delivery-estimation');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var target = el.querySelector('[data-delivery-text]');
      if (!target) continue;
      var min = parseInt(el.dataset.minDays, 10);
      var max = parseInt(el.dataset.maxDays, 10);
      if (!min || !max) continue;
      var cutoff = parseInt(el.dataset.cutoffHour, 10) || 0;
      var now = new Date();
      var extra = now.getHours() >= cutoff ? 1 : 0;
      var from = addDaysSkipSunday(now, min + extra);
      var to = addDaysSkipSunday(now, max + extra);
      var sameMonth = from.getMonth() === to.getMonth();
      var text = 'Livraison estimée le ' + fmt(from, !sameMonth) + ' au ' + fmt(to, true);
      if (target.textContent !== text) target.textContent = text;
      // le thème peut réécrire son propre calcul après nous → on garde la main
      if (!el.__r42delObs && window.MutationObserver) {
        el.__r42delObs = true;
        new MutationObserver(function () { applyDeliverySundayOnly(); })
          .observe(target, { childList: true, characterData: true, subtree: true });
      }
    }
  }
  if (document.readyState !== 'loading') applyDeliverySundayOnly();
  else document.addEventListener('DOMContentLoaded', applyDeliverySundayOnly);
  // l'élément custom peut s'upgrader tard : on retente brièvement
  var delTries = 0;
  var delTimer = setInterval(function () {
    applyDeliverySundayOnly();
    if (++delTries > 15) clearInterval(delTimer);
  }, 300);

  /* ----------------------------------------------------------------
     Case « jours » sur le compte à rebours de la barre sticky.
     Le markup du thème n'a que heures:minutes:secondes. Sur une offre
     à date fixe (fin d'été = 31/08), il reste des dizaines de jours :
     le thème affiche alors les heures modulo 24, donc « 04:31:15 » pour
     36 jours restants → le visiteur lit « ça finit dans 4 h », c'est faux
     et ça se voit (le lendemain il relit ~4 h). On préfixe donc « 36j ».
     On n'écrase jamais les cases du thème : on ajoute la nôtre à côté,
     donc son tick d'une seconde continue de piloter h/m/s tout seul.
     ---------------------------------------------------------------- */
  function stickyEndDate() {
    var src = document.querySelector('acjjdo-countdown[data-mode="fixed"][data-end-date]');
    if (!src) return null;                        // mode session → rien à faire
    var t = Date.parse(src.getAttribute('data-end-date'));
    return isNaN(t) ? null : t;
  }

  function paintStickyDays() {
    var box = document.querySelector('[data-sticky-countdown]');
    var end = stickyEndDate();
    if (!box || end === null) return false;

    var cell = box.querySelector('[data-r42-days]');
    if (!cell) {
      cell = document.createElement('span');
      cell.setAttribute('data-r42-days', '');
      cell.style.marginRight = '0.35em';
      box.insertBefore(cell, box.firstChild);
    }

    var days = Math.floor((end - Date.now()) / 86400000);
    if (days > 0) {
      cell.textContent = days + 'j';
      cell.hidden = false;
    } else {
      cell.hidden = true;                         // dernier jour → h:m:s suffit et redevient vrai
    }
    return true;
  }

  // Une passe par seconde suffit : la case ne bouge qu'une fois par jour,
  // mais le sticky est rendu tard et peut être re-rendu (variante, panier).
  if (document.querySelector('[data-sticky-countdown], acjjdo-countdown')) {
    paintStickyDays();
    setInterval(paintStickyDays, 1000);
  }
})();
